export default "__VITE_ASSET__C69MN84k__"